import React, { useEffect, useState } from "react";
import bannerImage from "../../assests1/About-us/screen1.png";

import software from "../../assests1/About-us/software.jpg";
import enterprise from "../../assests1/About-us/erp.png";
import dataWarehouse from "../../assests1/About-us/DataWarehouse.png";
import bi from "../../assests1/About-us/BI.jpg";
import teamImage from "../../assests1/About-us/ourteam.png";
import productImage from "../../assests1/About-us/commitment.png";
import sankaraLogo from "../../assests1/About-us/sankara.png";

const AboutUs = ({ onBack }) => {
  const useSlideshow = (images, interval = 4000) => {
    const [index, setIndex] = useState(0);
    useEffect(() => {
      const id = setInterval(() => {
        setIndex((prev) => (prev + 1) % images.length);
      }, interval);
      return () => clearInterval(id);
    }, [images, interval]);
    return { current: images[index], index };
  };

  const expertiseImages = [software, enterprise, dataWarehouse, bi];
  const { current: expertiseCurrent } = useSlideshow(expertiseImages, 4000);

  const sections = [
    {
      title: "Our Expertise",
      image: expertiseCurrent,
      delay: "0.4s",
      content: (
        <>
          <p className="mb-3 text-white">
            Founded in 1986, Sankara has evolved into a leading software
            development and consulting firm. Since 2001, we have strategically
            focused on next-generation solutions in niche areas such as:
          </p>
          <ul className="list-none mb-3 ml-4 space-y-2">
            <li className="flex items-start gap-2">
              <span className="text-[#F4A62A] font-bold">➤</span>
              <span className="text-white">Enterprise Applications</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#F4A62A] font-bold">➤</span>
              <span className="text-white">Data Warehousing</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#F4A62A] font-bold">➤</span>
              <span className="text-white">
                Enterprise Business Intelligence
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#F4A62A] font-bold">➤</span>
              <span className="text-white">Web-enabled Solutions</span>
            </li>
          </ul>
          <p className="text-white">
            Our state-of-the-art development center in Chennai, India, serves
            both domestic and international clients with world-class software
            solutions.
          </p>
        </>
      ),
    },
    {
      title: "Our Team",
      image: teamImage,
      delay: "0.55s",
      content: (
        <>
          <p className="mb-3 text-white">
            We take pride in our highly skilled and dedicated team, which
            includes:
          </p>
          <ul className="list-none mb-3 ml-4 space-y-2">
            <li className="flex items-start gap-2">
              <span className="text-[#F4A62A] font-bold">➤</span>
              <span className="text-white">
                Certified professionals in technology, domain expertise, and
                consulting
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#F4A62A] font-bold">➤</span>
              <span className="text-white">PMP-certified project managers</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#F4A62A] font-bold">➤</span>
              <span className="text-white">
                A process-driven development team
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#F4A62A] font-bold">➤</span>
              <span className="text-white">
                Specialists in multi-platform custom software and product
                development
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#F4A62A] font-bold">➤</span>
              <span className="text-white">
                Functional consultants with deep domain knowledge
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#F4A62A] font-bold">➤</span>
              <span className="text-white">
                A customer-centric account management approach
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#F4A62A] font-bold">➤</span>
              <span className="text-white">
                Robust program and delivery management practices
              </span>
            </li>
          </ul>
        </>
      ),
    },
    {
      title: "Our Products and Commitment",
      image: productImage,
      delay: "0.7s",
      content: (
        <>
          <p className="mb-3 text-white">
            One of our software products,{" "}
            <strong>
              <span className="text-yellow-500">Resi</span>
              <span className="text-white">Link</span>
            </strong>
            , is a comprehensive apartment and community management software
            designed for India and South Asian markets. Over the past 25+ years,
            Sankara has developed numerous successful software products for
            clients in the USA, Canada, and the UK.
          </p>
          <p className="mb-3 text-white">
            Every in-house product undergoes a full software development
            lifecycle and is backed by a responsive support team that resolves
            issues—typically within 24 hours, depending on complexity. Our
            engineers are not only technically qualified but also deeply
            committed to seeing each product through development, marketing, and
            seamless knowledge transfer to support teams.
          </p>
          <p className="mb-3 text-white font-semibold">
            Our collaborative culture includes subject matter experts and
            software architects who contribute methodically to every project.
            With over 40 years of experience, we are proud to have consistently
            delivered exceptional software and support to our clients—earning
            their trust and satisfaction time and again.
          </p>
          <p className="font-semibold text-white">
            At Sankara, we never let our clients down. That's our promise.
          </p>
        </>
      ),
    },
  ];

  return (
    <div
      className="min-h-screen bg-cover bg-center bg-no-repeat bg-fixed py-24"
      style={{
        backgroundImage: `url(${bannerImage})`,
        backgroundColor: "#0b1623",
        backgroundBlendMode: "overlay",
      }}
    >
      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Header Section */}
        <div className="text-center mb-12 animate-[fadeInUp_1s_ease_forwards] opacity-0">
          <h1 className="text-3xl md:text-4xl font-bold mb-4 tracking-wide text-white">
            About Sankara Software Services Private Limited
          </h1>

          <img
            src={sankaraLogo}
            alt="Sankara Logo"
            className="mx-auto mb-6 w-32 md:w-40 h-auto bg-white p-4 rounded-lg text-white"
          />

          <p className="text-white max-w-3xl mx-auto text-md leading-relaxed">
            Sankara Software Services Private Limited is a company incorporated
            in India, with a global footprint, operating delivery centers and
            offices in the United States, Canada, and India. Our mission is to
            deliver information technology solutions and customer support
            services that empower businesses to grow and thrive. We believe in
            forging strong partnerships with our clients, working
            collaboratively to drive continuous innovation.
          </p>
        </div>

      
        <div className="space-y-20">
          {sections.map((section, index) => (
            <div
              key={index}
              className="grid md:grid-cols-2 gap-12 items-center animate-[fadeInUp_1s_ease_forwards] opacity-0"
              style={{ animationDelay: section.delay }}
            >
            
              <div className="relative w-full rounded-xl shadow-lg bg-white/80 backdrop-blur-sm flex justify-center items-center h-72 md:h-80 overflow-hidden">
                <img
                  key={section.image}
                  src={section.image}
                  alt={section.title}
                  className="w-full h-full object-cover animate-[fadeInImg_1s_ease_forwards]"
                />
              </div>

              <div>
                <h2 className="text-2xl font-semibold mb-4 text-white">
                  {section.title}
                </h2>
                <div className="text-md leading-relaxed text-white">
                  {section.content}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

     
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(25px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInImg {
          from {
            opacity: 0;
            transform: scale(1.05);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
};

export default AboutUs;
